/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 1st 2021, 8:44:14 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useGlobalScope } from "core/providers";
import { ProcessTemplateArtifact } from "lib/schemas";

/**
 * Utility hook to get a default ProcessTemplateArtifact object with the current selected organization
 *
 * @returns A default ProcessTemplateArtifact object with the current selected organization
 * set as the artifact_org.
 */
export const useDefaultProcessTemplateArtifact = (): ProcessTemplateArtifact => {
  const { globalState } = useGlobalScope();

  return { artifact_org: globalState.selectedOrganization?.id };
};
